import { render, staticRenderFns } from "./MassImportBody.vue?vue&type=template&id=6b000afa&scoped=true&"
import script from "./MassImportBody.vue?vue&type=script&lang=ts&"
export * from "./MassImportBody.vue?vue&type=script&lang=ts&"
import style0 from "./MassImportBody.vue?vue&type=style&index=0&id=6b000afa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b000afa",
  null
  
)

export default component.exports